import { PartialNullable } from "../../../Extensions";
import { Property } from "../../../RadObject";
import { IText, Text, TextPropertyValues } from "../Text";
import { NAMESPACE } from "./_Namespace";

export type TextPasswordPropertyValues =
    TextPropertyValues
    & {
    };

export type TextPasswordProperties = {
    [name in keyof TextPasswordPropertyValues]: Property<TextPasswordPropertyValues[name]>
};

export interface ITextPassword extends IText, TextPasswordProperties
{
}

export class TextPassword extends Text implements ITextPassword
{
    public static override classNamespace = NAMESPACE + "TextPassword";
    public static override className = "TextPassword";

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TextPasswordPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Public Methods

    protected override __initializeProperties(propertyValues: TextPasswordPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.text.overrideSet((value, next) =>
        {
            next(value ? "****************" : null);
        });
    }

    // #endregion
}

